'use client';
import { Combobox as Combobox$1 } from './Combobox.js';
import { ComboboxEmpty } from './Empty.js';
import { ComboboxOption } from './Option/Option.js';

/**
 * @deprecated Use `Suggestion` instead
 */
const Combobox = Combobox$1;
Combobox.Option = ComboboxOption;
Combobox.Empty = ComboboxEmpty;
Combobox.Option.displayName = 'Combobox.Option';
Combobox.Empty.displayName = 'Combobox.Empty';

export { Combobox, ComboboxEmpty, ComboboxOption };
